import baseService from './baseService';
import config from '../../config';

export default{
    sendEnquiry(params) {
        return baseService.post(config.API_LOCATION + 'general/sendEnquiry',params)
    },
    getPages(){
        return baseService.get(config.API_LOCATION + 'pages',{});
    },
    getSliders(){
        return baseService.get(config.API_LOCATION + 'sliders',{});
    },
    sendNeedsAnalysisForm(params){
        return baseService.post(config.API_LOCATION + 'general/sendAnalysisForm',params)
    }

}

